"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWarnContext_1 = __importDefault(require("@seaweb/coral/hooks/useWarnContext"));
var setDisplayName_1 = __importDefault(require("@seaweb/coral/utils/setDisplayName"));
var TabsOrientations;
(function (TabsOrientations) {
    TabsOrientations["Horizontal"] = "horizontal";
    TabsOrientations["Vertical"] = "vertical";
})(TabsOrientations || (TabsOrientations = {}));
exports.TabsOrientations = TabsOrientations;
var TabVariants;
(function (TabVariants) {
    TabVariants["Bar"] = "bar";
    TabVariants["Text"] = "text";
    TabVariants["Card"] = "card";
})(TabVariants || (TabVariants = {}));
exports.TabVariants = TabVariants;
var TabsContext = react_1.createContext(null);
var useTabsContext = function () { return useWarnContext_1.default(TabsContext); };
exports.useTabsContext = useTabsContext;
setDisplayName_1.default(TabsContext, 'TabsContext');
var TabListContext = react_1.createContext(null);
exports.TabListContext = TabListContext;
var useTabListContext = function () { return useWarnContext_1.default(TabListContext); };
exports.useTabListContext = useTabListContext;
setDisplayName_1.default(TabListContext, 'TabListContext');
var TabPanelsContext = react_1.createContext(null);
exports.TabPanelsContext = TabPanelsContext;
var useTabPanelsContext = function () { return useWarnContext_1.default(TabPanelsContext); };
exports.useTabPanelsContext = useTabPanelsContext;
setDisplayName_1.default(TabPanelsContext, 'TabPanelsContext');
exports.default = TabsContext;
